import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { Table, Breadcrumb, Badge } from 'react-bootstrap';
import { AiOutlinePlusCircle } from 'react-icons/ai';

import FonctionService from 'Services/FonctionService';

const Apps = () => {
    const [fonctions, setFonctions] = useState([]);

    useEffect(() => {
        FonctionService.getFonctions()
            .then((result) => {
                if (result.status === 200) {
                    setFonctions(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    const getParent = (id) => {
        return fonctions.find((fonction) => {
            return fonction.fonctionId === id;
        });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Fonctions</Breadcrumb.Item>
            </Breadcrumb>
            <div className="d-flex justify-content-between align-items-center py-2">
                <h2>Fonctions</h2>
                <Link to="/admin/fonction/create">
                    <button className="btn btn-outline-primary btn-sm">
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                </Link>
            </div>

            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Fonction</th>
                        <th>Fonction Parent</th>
                        <th>Group</th>
                        <th>Projet</th>
                        <th>Permissions</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {fonctions.length ? (
                        fonctions.map((fonction, key) => {
                            return (
                                <tr key={key}>
                                    <td>{fonction.name}</td>
                                    <td>{fonction.parentId ? getParent(fonction.parentId).name : '-'}</td>
                                    <td>{fonction.group ? fonction.group.name : '-'}</td>
                                    <td>{fonction.projet ? fonction.projet.name : '-'}</td>
                                    <td>
                                        {fonction.fonctionPermissions && fonction.fonctionPermissions.length > 0 && (
                                            <>
                                                {fonction.fonctionPermissions[0].dA_VALIDATOR && (
                                                    <Badge>DA_VALIDATOR</Badge>
                                                )}
                                                {fonction.fonctionPermissions[0].selF_DA_VALIDATOR && (
                                                    <Badge>SELF_DA_VALIDATOR</Badge>
                                                )}
                                                {fonction.fonctionPermissions[0].directDAFonction && (
                                                    <Badge>
                                                        DIRECT_DA :{' '}
                                                        {fonction.fonctionPermissions[0].directDAFonction.name}
                                                    </Badge>
                                                )}
                                            </>
                                        )}
                                    </td>
                                    <td>
                                        <Link to={`/admin/fonction/edit/${fonction.fonctionId}`}>
                                            <img
                                                src="/images/edit.svg"
                                                alt=""
                                                style={{
                                                    height: '15pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to={`/admin/fonction/delete/${fonction.fonctionId}`}>
                                            <img
                                                src="/images/delete.svg"
                                                alt=""
                                                style={{
                                                    height: '18pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="6">no data</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default Apps;
